import { Component, OnInit } from '@angular/core';
import { SectorsService, sectorslist } from 'src/app/shared/services/sectors.service';
import { RegionsService, Region } from 'src/app/shared/services/regions.service';
import { CustomerService, Customer } from 'src/app/shared/services/customer.service';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { Message } from 'primeng/api/message';
import { ConfirmationService, SelectItem } from 'primeng/api';
import { trigger,state,style,transition,animate } from '@angular/animations';

import * as $ from 'jquery';

@Component({
  selector: 'app-customermanagement',
  templateUrl: './customermanagement.component.html',
  styleUrls: ['./customermanagement.component.scss'],
})
export class CustomermanagementComponent implements OnInit {
  
  customersList: Customer[] = new Array();

  constructor(private confirmationService: ConfirmationService,private sectorsService: SectorsService,private  regionService: RegionsService, private customerService : CustomerService) { 
    this.createForm();
  }

  msgs: Message[] = [];
  sectorList: sectorslist[];
  public regionsList: Region[];
  myGroup: UntypedFormGroup;
  displayDialog : boolean = false;
  public addEditUserHeader = "Create Customer";

  sectors: any[] = new Array();
  regions: any[] = new Array();
  
  async ngOnInit(): Promise<void> {
    $("body").css("overflow-y", "hidden");

    await this.sectorsService.getsectorsList().toPromise().then(response =>{this.sectorList = response;
    
      for (let index = 0; index < this.sectorList.length; index++) {
        const element = this.sectorList[index];

        this.sectors.push({label:element.sector, value:element.sector});
        
      }
    });
    await this.regionService.getRegions().toPromise().then(response =>{this.regionsList = response;
    
      for (let index = 0; index < this.regionsList.length; index++) {
        const element = this.regionsList[index];

        this.regions.push({label:element.region, value:element.region});
        
      }
    });
    this.retrieveCustomers();
    
     // Spinner 
     $(".spinner-container").fadeOut();
     $("body").css("overflow-y", "auto");
  }

  
  async retrieveCustomers(){
    await this.customerService.retrieveAllCustomers().toPromise().then(response =>{ this.customersList = response;});
  }

  createForm() {

    this.myGroup  = new UntypedFormGroup({
      email: new UntypedFormControl(null, [ Validators.required , Validators.email]),
      customerNumber: new UntypedFormControl(null, [Validators.required]),
      customerName: new UntypedFormControl(null, [Validators.required]),
      customerGroupName: new UntypedFormControl(null, [Validators.required]),
      sector: new UntypedFormControl(null, [Validators.required]),
      region:  new UntypedFormControl(null, [Validators.required]), 
      contactPerson : new UntypedFormControl(null, [Validators.required]), 
      mobile : new UntypedFormControl(null, [Validators.required]), 
    });    
  }

  public onDeleteCustomer(customerId: number){
    this.confirmationService.confirm({
      message: 'Do you want to delete the Customer?',
      header: 'Delete Confirmation',
      icon: 'pi pi-info-circle',
       accept: () => {
          this.deleteCustomer(customerId);
      },
      reject: () => {}
  });
  }

  public deleteCustomer(customerId: number){
    this.customerService.deleteCustomer(customerId).subscribe(
      (data) =>{      
        this.deleteCustomerRow(customerId);
        this.showMsg('info', 'Confirmed', 'Customer deleted');
    },
    (error) => {
      this.showMsg('error', 'Rejected', 'Error happened while deleting!!!');
    }); 
  }

  public deleteCustomerRow(id: number){
    var index = 0;
    for (var i=0; this.customersList; i++){
      if (this.customersList[i].customerId == id){
      index = i;
      break;
      }
    }
    this.customersList = this.customersList.slice(0, index).concat( this.customersList.slice(index+1) );
  }

  public showMsg(severity: string, summary: string, detail: string){
    this.msgs = [{severity: severity, summary:summary, detail:detail}];
    setTimeout(()=>{ this.msgs = []}, 2000);
  }

  public customerId : number ;
  public customerDTO : Customer =  new Customer();

  public openCustomerDialog(event){

    //console.log("open dialog for adding user");
    this.displayDialog = true;
    this.customerId = -1;
    this.customerDTO = new Customer();
    this.addEditUserHeader = "Create Customer";
    this.createForm(); 
    this.myGroup.reset();

  }

  public closeDialog(event){
    this.displayDialog = false;
  }

  public editUserData(editUserId:any){
    //console.log("userId :" + editUserId);
    this.customerId = editUserId;
    this.displayDialog= true;
    this.customerDTO = new Customer();
    this.addEditUserHeader = "Modify Customer Details";
    this.createForm(); 
    this.myGroup.reset();

    for (var i=0; this.customersList; i++){
      if (this.customersList[i].customerId == editUserId){
        this.customerDTO = this.customersList[i];
        break;
      }
    }
    //console.log(this.userDTO);
    this.myGroup.controls.email.setValue(this.customerDTO.email);
    this.myGroup.controls.customerNumber.setValue(this.customerDTO.customerNumber);
    this.myGroup.controls.customerName.setValue(this.customerDTO.customerName);
    this.myGroup.controls.customerGroupName.setValue(this.customerDTO.customerGroupName);
    this.myGroup.controls.sector.setValue(this.customerDTO.sector.sectorId);
    this.myGroup.controls.region.setValue(this.customerDTO.region.regionId);
    this.myGroup.controls.contactPerson.setValue(this.customerDTO.contactPersonName);
    this.myGroup.controls.mobile.setValue(this.customerDTO.mobileNumber);
  }

  
  onSubmit(event) {

    for (let controller in this.myGroup.controls) {
      this.myGroup.get(controller).markAsTouched();
    }

    //console.log("this.myGroup.valid : "+ this.myGroup.valid);
       
    if (event.submitter.id=="finish")
    {
      if(this.myGroup.valid) 
      {
        // console.log("form is valid");
        if (this.customerId!=-1){
          //console.log("edit customer details ....");

          this.displayDialog = false;
          this.updateCustomer();
        }
        else {
          //console.log("add customer details ....");
          this.displayDialog = false;
          this.createCustomer();
        }
      }
      else {
        // console.log("form is invalid");
      }
    }
  }

  createCustomer(){

    this.customerService.createCustomer(this.customerDTO).subscribe(
      (data) =>{      
        this.showMsg('info', 'Confirmed', 'Customer Created Successfully !!!');
        this.displayDialog = false;
        this.retrieveCustomers();
    },
    (error) => {
      this.displayDialog = false;
      this.showMsg('error', 'Rejected', 'Error happened while Customer Creation!!!');
    }); 

  }

  updateCustomer(){

    this.customerService.updateUser(this.customerDTO).subscribe(
      (data) =>{      
        this.showMsg('info', 'Confirmed', 'Customer Details Modified Successfully !!!');
        this.displayDialog = false;
        this.retrieveCustomers();
    },
    (error) => {
      this.displayDialog = false;
      this.showMsg('error', 'Rejected', 'Error happened while Customer details modification!!!');
    }); 

  }
  
}
